import React from "react";
import Header from "../navigation/header";
import Work from "./work";
import Footer from "../navigation/footer";

export default function WorkPage (){
    return(
        <>
            <Header />
            <Work />
            <Footer />
        </>
    )
}